export default __webpack_public_path__ + "static/more-info-06d1fa2502d4101c141a686c598b0ad4.png";